// 22.01.19 - This interface file describes the reducer structure.
// import { routerReducer } from "react-router-redux";
import { connectRouter } from "connected-react-router";
import { combineReducers } from "redux";
import { homeReducer, IHomeState } from "./home";
import { commonReducer, ICommonState } from "./common";
import { detailReducer, IDetailState } from "./detail";
import { reducer as formReducer } from "redux-form";
import { userProfileReducer } from "../components/user-profile/reducers";

export interface IRootState {
  home: IHomeState;
  common: ICommonState;
  form: any;
  detail: IDetailState;
  userProfile: any;
  router: any;
}

// export const rootReducer: Reducer<IRootState> = combineReducers({
//   home: homeReducer, // This reducer controls the state of the view.
//   form: formReducer, // This reducer is given to the app by Redux. This controls the state of the form so that. This listens to the different Redux form actions.
//   routing: connectRouter(history),
//   common: commonReducer,
//   detail: detailReducer,
// });

const createRootReducer = (history: any) =>
  combineReducers({
    router: connectRouter(history),
    home: homeReducer, // This reducer controls the state of the view.
    form: formReducer, // This reducer is given to the app by Redux. This controls the state of the form so that. This listens to the different Redux form actions.
    common: commonReducer,
    detail: detailReducer,
    userProfile: userProfileReducer,
  });
export default createRootReducer;
